import { useTranslation } from 'react-i18next';

interface CountdownChipProps {
  daysLeft: number;
  label?: string;
  className?: string;
}

export function CountdownChip({ daysLeft, label, className = '' }: CountdownChipProps) {
  const { t } = useTranslation();
  const variant =
    daysLeft <= 3 ? 'danger' : daysLeft <= 7 ? 'warning' : 'primary';

  const styles = {
    danger: 'bg-danger-50 text-danger-700 border-danger-200',
    warning: 'bg-warning-50 text-warning-700 border-warning-200',
    primary: 'bg-primary-50 text-primary-700 border-primary-100',
  };

  const text =
    daysLeft === 0
      ? t('countdown_chip.today')
      : t('countdown_chip.days_left', { count: daysLeft });

  return (
    <span
      aria-label={label ? t('countdown_chip.with_label', { label, text }) : text}
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${styles[variant]} ${className}`}
    >
      {daysLeft <= 3 && <span aria-hidden="true">⚡</span>}
      {text}
    </span>
  );
}
